var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card-text',{staticClass:"textBotao"},[_vm._v("\n   \n    Conheça as vantagens do Protesto de Títulos como opção de recuperação de crédito!\n    O Protesto de Títulos é 60% mais eficientes que os outros métodos de recuperação de crédito! Clique e saiba mais!\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }